import { Cookies } from 'react-cookie';

import { InteractiveMapPlanDelete } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const deleteInteractiveMapPlan = async (object: InteractiveMapPlanDelete) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const { data } = await axiosInterceptor.delete(`v1/objects/${object.site_slug}/plans/${object.slug}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data as any;
};
